import { Reveal } from "@components/ui";
import partnershipsImg from "@assets/images/Group-1410087744.svg";

const partnerships = [
  {
    name: "Dubai Corporation for Ambulance Services (DCD)",
    dotColor: "#f03813",
  },
  {
    name: "Emirates Authority for Standardization (ESMA)",
    dotColor: "#122d63",
  },
  {
    name: "International Gas Union (IGU)",
    dotColor: "#1a7a4f",
  },
  {
    name: "UAE Ministry of Energy & Infrastructure",
    dotColor: "#d4880f",
  },
];

const PartnershipsSection = () => {
  return (
    <section className="bg-[#f9f9fb] py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="max-w-[1368px] mx-auto">
        {/* Header */}
        <Reveal>
          <div className="text-center mb-12 lg:mb-16">
            <span className="inline-block rounded-full bg-[#e6f5ed] px-4 py-1.5 text-sm font-medium text-[#1a7a4f] mb-4">
              Collaboration
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-[42px] font-bold text-[#090d2c] leading-tight mb-4">
              Partnerships & Collaborations
            </h2>
            <p className="text-[#62636c] text-base md:text-lg max-w-[640px] mx-auto">
              Working together for a sustainable energy future
            </p>
          </div>
        </Reveal>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: Description + partnership list */}
          <Reveal>
            <div>
              <p className="text-[#62636c] text-base md:text-lg leading-relaxed mb-8">
                GASIS actively collaborates with government entities, industry
                partners, and international organizations to advance sustainable
                energy practices across the UAE.
              </p>

              <ul className="space-y-4">
                {partnerships.map((partner) => (
                  <li key={partner.name} className="flex items-center gap-3">
                    <span
                      className="flex-shrink-0 w-3 h-3 rounded-full"
                      style={{ backgroundColor: partner.dotColor }}
                    />
                    <span className="text-[#090d2c] text-base md:text-lg font-medium">
                      {partner.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* Right: Image */}
          <Reveal>
            <div className="rounded-[24px] overflow-hidden shadow-sm">
              <img
                src={partnershipsImg}
                alt="GASIS Partnerships and Collaborations"
                className="w-full h-auto object-cover"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default PartnershipsSection;
